module.exports = __webpack_public_path__ + "img/icon-stats@350h.92e5be8d.png";